import { Button } from "@/components/ui/button";
import { usePortalDetail } from "@/routes/portals.$id";
import { Link, createFileRoute } from "@tanstack/react-router";
import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/portals/$id/api")({
	component: ApiTab,
});

function ApiTab() {
	const { t } = useTranslation("portals");
	const ctx = usePortalDetail();
	const keyPrefix =
		ctx.keys.find((k) => !k.revokedAt)?.tokenPrefix ?? "omnios_sk_****";
	const apiUrl = ctx.portalApiUrl;

	return (
		<div className="space-y-6 max-w-xl">
			<h2 className="text-lg font-semibold">{t("api_title")}</h2>
			<p className="text-sm text-muted-foreground">{t("api_desc")}</p>

			<div className="space-y-3">
				<Row label={t("base_url")} mono>
					{apiUrl}
				</Row>
				<Row label={t("authorization")} mono>
					X-API-Key: {keyPrefix}...
				</Row>
				<Row label={t("search")} mono>
					GET /api/v1/portal/search?q=…
				</Row>
				<Row label={t("suggestions")} mono>
					GET /api/v1/portal/suggest?q=…
				</Row>
				<Row label={t("product")} mono>
					GET /api/v1/portal/products/:id
				</Row>
				<Row label={t("api_catalog")} mono>
					GET /api/v1/portal/catalog
				</Row>
				<Row label={t("api_properties")} mono>
					GET /api/v1/portal/property-definitions
				</Row>
				<Row label={t("api_categories")} mono>
					GET /api/v1/portal/categories
				</Row>
				<Row label={t("api_keys_endpoint")} mono>
					POST /api/v1/portal/keys
				</Row>
			</div>

			<div className="flex gap-3 pt-2">
				<Button variant="outline" size="sm" asChild>
					<Link to="/docs/portal/endpoints">
						<ExternalLink className="h-3.5 w-3.5 mr-1.5" />
						{t("api_docs")}
					</Link>
				</Button>
				<Button variant="outline" size="sm" asChild>
					<Link to="/docs/portal/widget">
						<ExternalLink className="h-3.5 w-3.5 mr-1.5" />
						{t("widget_docs")}
					</Link>
				</Button>
			</div>
		</div>
	);
}

function Row({
	label,
	children,
	mono,
}: { label: string; children: React.ReactNode; mono?: boolean }) {
	return (
		<div className="flex items-baseline gap-3">
			<span className="text-xs text-muted-foreground w-28 shrink-0 text-right">
				{label}
			</span>
			<span className={`text-sm ${mono ? "font-mono" : ""}`}>
				{children}
			</span>
		</div>
	);
}
